module.exports = __webpack_public_path__ + "static/media/better_prof.d821abbe.png";